const firebaseConfig = {
  apiKey: 'AIzaSyCoWoENixUVHz43t4BfL0DK6fiMrmBKDs4',
  authDomain: 'rapihogar-1496755516806.firebaseapp.com',
  databaseURL: 'https://rapihogar-1496755516806.firebaseio.com',
  projectId: 'rapihogar-1496755516806',
  storageBucket: 'rapihogar-1496755516806.appspot.com',
  messagingSenderId: '118480623465',
  appId: '1:118480623465:web:73a80737925ff1e5458ff8'
}

export default firebaseConfig
